import React from 'react';

export const MoneyBackIcon = () => (
  <svg width="18px" height="22px" viewBox="0 0 18 22" version="1.1">
    <g stroke="none" strokeWidth="1" fill="#4CAF50" fillRule="evenodd">
      <path d="M9,0 L0,4 C0,4 0,8 0,10 C0,17.83 6.439,21.486 9,22 C11.561,21.486 18,17.83 18,10 C18,8 18,4 18,4 L9,0 Z M8,15.414 L3.815,11.229 L5.229,9.815 L8,12.586 L13.792,6.794 L15.206,8.208 L8,15.414 Z" />
    </g>
  </svg>
);
